import { HttpErrorResponse } from "@angular/common/http";
import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../core/auth/auth.service";
import { ErrorService } from "../../core/services/error.service";

@Component({
    selector: "app-one-time-code",
    standalone: true,
    imports: [],
    templateUrl: "./one-time-code.component.html",
})
export class OneTimeCodeComponent {
    private _activatedRoute = inject(ActivatedRoute);
    private _authService = inject(AuthService);
    private _errorService = inject(ErrorService);
    private _router = inject(Router);

    ngOnInit(): void {
        const shortLink = this._activatedRoute.snapshot.params["shortLink"];
        const oneTimeCode = this._activatedRoute.snapshot.params["oneTimeCode"];
        this._authService.verifyOneTimeCode(shortLink, oneTimeCode).subscribe({
            next: () => {
                this._router.navigateByUrl(`/${shortLink}`);
            },
            error: (error: HttpErrorResponse) => {
                this._errorService.setError(
                    error.error?.message || "Invalid one-time code."
                );
            },
        });
    }
}
